import Title from "../components/TheTitle.vue";
import { Validation } from "../utils/validation";
import { getBrandsMaster, getStoresMaster } from "../api";
export default {
    name: "PointSetting",
    props: {
        visible: { type: Boolean, required: true }, // モーダル表示制御（親から管理）
    },
    components: {
        Title,
    },
    data() {
        return {
            brandInfo: [],
            storeInfo: [],
            form: {
                brand: "",
                store: "",
                point_name: "",
                point_grant_reason: "",
                points: "",
                effective_period_date: "",
            },
        };
    },
    computed: {
        isDeductionMode() {
            return Number(this.form.points) < 0;
        },
    },
    async created() {
        await this.callApi();
    },
    methods: {
        close() {
            // 親に閉じるイベントを通知（親側で visible を false にしてください）
            this.$emit("close");
        },
        // 「ポイント設定」ボタンのハンドラ
        handleSetting() {
            const errorMessage = this.validate(this.form);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            this.$store.commit("setPointSetting", this.form);
            // 閉じる
            this.close();
        },
        validate(form) {
            const errors = [];
            const isDeductionMode = Number(form.points) < 0;
            // 必須入力チェック
            errors.push(...Validation.requiredInput({ key: "ブランド", value: form.brand }));
            errors.push(...Validation.requiredInput({ key: "付与店舗", value: form.store }));
            errors.push(...Validation.requiredInput({
                key: "ポイント名",
                value: form.point_name,
            }));
            errors.push(...Validation.requiredInput({ key: "付与ポイント", value: form.points }));
            if (!isDeductionMode) {
                errors.push(...Validation.requiredInput({
                    key: "有効期限",
                    value: form.effective_period_date,
                }));
            }
            // 桁数チェック
            errors.push(...Validation.digitsMax({
                key: "ポイント名",
                value: form.point_name,
            }, 100));
            if (form.point_grant_reason) {
                errors.push(...Validation.digitsMax({
                    key: "詳細説明",
                    value: form.point_grant_reason,
                }, 500));
            }
            errors.push(...Validation.digitsMax({
                key: "付与ポイント数",
                value: form.points,
            }, 6));
            if (!isDeductionMode) {
                errors.push(...Validation.digitsMax({
                    key: "有効期限",
                    value: form.effective_period_date,
                }, 10));
            }
            // 属性チェック：付与ポイント数は負の整数も許可
            if (form.points && !/^-?[0-9]+$/.test(String(form.points))) {
                errors.push("付与ポイント数は整数で入力してください。");
            }
            if (!isDeductionMode) {
                errors.push(...Validation.isInteger({
                    key: "有効期限",
                    value: form.effective_period_date,
                }));
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
        async callApi() {
            const gbResponse = await getBrandsMaster("OPS");
            if (gbResponse.result?.code === 9) {
                this.$store.commit("setMessages", gbResponse.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.brandInfo = gbResponse.data.results;
            }
        },
    },
    watch: {
        "form.brand": async function (newBrand) {
            if (!newBrand || !newBrand.brandId) {
                this.storeInfo = [];
                return;
            }
            try {
                const response = await getStoresMaster(newBrand.brandId);
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.storeInfo = response.data.results;
                }
            }
            catch (err) {
                console.error(err);
            }
        },
    },
};
